import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import browser from 'Cloud/browser';
import {
    ANONYM_USER,
    IS_B2B_BIZ_USER,
    IS_CORP_USER,
    IS_DOCUMENTS_DOMAIN,
    IS_MY_TEAM,
    IS_ONPREMISE,
    IS_PAID_USER,
    IS_PHONE_BROWSER,
} from 'reactApp/appHelpers/configHelpers';

const DISABLE_FEATURE = IS_B2B_BIZ_USER || IS_PHONE_BROWSER || IS_DOCUMENTS_DOMAIN || IS_ONPREMISE || IS_MY_TEAM || ANONYM_USER;

export const isAiRemoveBackgroundEnabled: boolean = !DISABLE_FEATURE && isFeature('ai-rmv-backgrnd');
export const isAiRemoveBackgroundDisableWebGPU: boolean =
    isFeature('ai-rmv-backgrnd-disable-webgpu') || ((browser.isSafari() || browser.isIOS()) && !isFeature('ai-rmv-backgrnd-webgpu-safari'));

export const fileTypesForAiRemoveBackground: string[] = getFeature('ai-rmv-backgrnd-file-exts') || ['png', 'jpg', 'jpeg'];

export const imgRemoveBackgroundModel: { name: string; dtype?: string } = getFeature('imgremove-model') || {
    // https://github.com/ZHKKKe/MODNet Apache 2
    name: 'modnet',
    dtype: 'q4f16',
};

export const AI_VIEWER_TOOLBAR_ID = 'ai_viewer_toolbar_id';

export const PROMO_ID = 'ai-photo-rmv-backgrnd';

/** id промо Попапа - для включения нужно будет включать фичу 3promo-enable-{id} */
export const PROMO_VIEWER_POPUP_ID = `${PROMO_ID}-vw-ppp-promo`;
/** Ключ для локалстораджа от попапа */
export const storageKeyForPopup = `${PROMO_VIEWER_POPUP_ID}-2`;
export const isAiRmvPromoViewerEnabled = isFeature(`3promo-enable-${PROMO_VIEWER_POPUP_ID}`);

/** Временной промежуток между показами одной и той же промки, в секундах */
export const showInterval: number = +getFeature(`${PROMO_VIEWER_POPUP_ID}-show-interval`) || 172800;
/** Максимальное количество закрытий промки (на крестик в баннере / на primary кнопку) */
export const closeLimit: number = +getFeature(`${PROMO_VIEWER_POPUP_ID}-close-limit`) || 3;
/** Максимальное количество показов, в которых не взаимодействуют с промкой */
export const showLimit: number = +getFeature(`${PROMO_VIEWER_POPUP_ID}-show-limit`) || 3;

/** id промо Тултипа - для включения нужно будет включать фичу 3promo-enable-{id} */
export const PROMO_TOOLTIP_POPUP_ID = `${PROMO_ID}-vw-tltp-promo`;
/** Ключ для локалстораджа от тултипа */
export const storageKeyForTootip = `${PROMO_TOOLTIP_POPUP_ID}-2`;
export const isAiRmvPromoTooltipViewerEnabled = isFeature(`3promo-enable-${PROMO_TOOLTIP_POPUP_ID}`);

/** Временной промежуток между показами одной и той же промки, в секундах */
export const showIntervalTooltip: number = +getFeature(`${PROMO_TOOLTIP_POPUP_ID}-show-interval`) || 172800;
/** Максимальное количество закрытий промки (на крестик в баннере / на primary кнопку) */
export const closeLimitTooltip: number = +getFeature(`${PROMO_TOOLTIP_POPUP_ID}-close-limit`) || 3;
/** Максимальное количество показов, в которых не взаимодействуют с промкой */
export const showLimitTooltip: number = +getFeature(`${PROMO_TOOLTIP_POPUP_ID}-show-limit`) || 3;

export const enableAiRmvPromoPopupAfterRmv: boolean =
    !DISABLE_FEATURE && !IS_CORP_USER && !IS_PAID_USER && isFeature('ai-photo-rmv-backgrnd-after-rmv');

/** id промо Попапа в Хомяке - для включения нужно будет включать фичу 3promo-enable-{id} */
export const PROMO_HOME_POPUP_ID = `${PROMO_ID}-hm-ppp-promo`;
/** Ключ для локалстораджа от попапа */
export const storageKeyForHomePopup = `${PROMO_HOME_POPUP_ID}`;
export const isAiRmvPromoHomeEnabled = isFeature(`3promo-enable-${PROMO_HOME_POPUP_ID}`);

/** id промо Попапа на странице Квоты - для включения нужно будет включать фичу 3promo-enable-{id} */
export const PROMO_QUOTA_POPUP_ID = `${PROMO_ID}-qw-ppp-promo`;
/** Ключ для локалстораджа от попапа */
export const storageKeyForQuotaPopup = `${PROMO_QUOTA_POPUP_ID}`;
export const isAiRmvPromoQuotaEnabled = isFeature(`3promo-enable-${PROMO_QUOTA_POPUP_ID}`);

/** id промо баннера - для включения нужно будет включать фичу 3promo-enable-{PROMO_BANNER_ID} */
export const PROMO_BANNER_ID = `ai-photo-rmv-backgrnd-banner`;
/** Ключ для локалстораджа */
export const storageKeyForBanner = PROMO_BANNER_ID;
/** Временной промежуток между показами одной и той же промки, в секундах */
export const showIntervalBanner: number = +getFeature(`${PROMO_BANNER_ID}-show-interval`) || 172800;
/** Максимальное количество закрытий промки (на крестик в баннере / на primary кнопку) */
export const closeLimitBanner: number = +getFeature(`${PROMO_BANNER_ID}-close-limit`) || 3;
/** Максимальное количество показов, в которых не взаимодействуют с промкой */
export const showLimitBanner: number = +getFeature(`${PROMO_BANNER_ID}-show-limit`) || 3;

export const aiRmvBgrndNoLimit: boolean = isFeature('ai-rmv-backgrnd-no-limit');
export const aiRmvBgrndPaymium: boolean = isFeature('ai-rmv-backgrnd-paymium');
export const aiRmvBgrndPaymiumLimit: number = getFeature('ai-rmv-backgrnd-paymium-limit') || 20;
export const aiRmvBgrndFreemiumLimit: number = getFeature('ai-rmv-backgrnd-freemium-limit') || 1;

export const aiRmvPromoQuotaTariffFeatures: boolean = isAiRemoveBackgroundEnabled && isFeature('ai-rmv-backgrnd-tariff-features');

export const aiRmvBgrndDebug = isFeature('ai-rmv-backgrnd-debug');

export const backgroundColors: { id: string }[] = (
    getFeature('ai-rmv-backgrnd-colors') || [
        'white',
        '#94B875',
        'black',
        '#81D8D0',
        '#424242',
        '#E2DCD5',
        '#4E342E',
        '#FFEBDC',
        '#5A355A',
        '#E7EED2',
        '#35385A',
        '#D0F0F7',
        '#646ECB',
        '#C9D0FA',
        '#EAB1C7',
        '#DDF3FF',
        '#E8857D',
    ]
).map((color) => ({
    id: color,
    type: 'color',
}));

export const backgroundImages: { id: string }[] = getFeature('ai-rmv-backgrnd-images') || [
    { id: '1' },
    { id: '6' },
    { id: '7' },
    { id: '4' },
    { id: '2' },
    { id: '3' },
    { id: '8' },
    { id: '5' },
];
